angular.module('unergie.main')
.factory('BoFeaturesService', ($rootScope, $state, DataAccessReferences) => {
    let features

    const promiseFunc = () => {
        return DataAccessReferences.ref({ id: 'bo-features' }).$promise.then((featureResult) => {
            features = featureResult.toJSON()
            $rootScope.boTitle = features.general.title
            return features
        }).catch((error) => console.log('Error while fetching features', error))
    }

    let getFeaturesPromise = promiseFunc()

    const refreshFeatures = () => {
        getFeaturesPromise = promiseFunc()
    }

    const getFeatures = () => getFeaturesPromise

    const getModuleFeatures = (modulename) => (features != null ? features[modulename] : {})

    const fieldTester = (modulename) =>
        function (field) {
            const fields = __guard__(getModuleFeatures(modulename), (x) => x.hideFields)
            if (fields === undefined) {
                return true
            }
            return fields.indexOf(field) === -1
        }


    const isFeatureOn = (featureName) => !!__guard__(getModuleFeatures('general'), (x) => x[featureName])

    const get = (featureName) => __guard__(getModuleFeatures('general'), (x) => x[featureName])

    const getEnv = () => __guard__(getModuleFeatures('general'), (x) => x.env)

    return {
        isFeatureOn,
        getFeatures,
        getModuleFeatures,
        fieldTester,
        get,
        refreshFeatures,
        getEnv,
    }
})

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}
